const SkeletonCard = () => {
  return (
    <div className="bg-white rounded-[16px] p-3 border border-gray-200 animate-pulse">
      <div className="flex items-start justify-between">
        <div className="flex-1 gap-1 min-w-0">
          {/* Ligne titre + numéro */}
          <div className="flex items-center gap-2 mb-1 justify-between">
            <div className="flex items-center justify-between w-full">
              <div className="h-[14px] bg-gray-200 rounded w-2/3"></div>
              <div className="h-[14px] bg-gray-200 rounded w-10 ml-2"></div>
            </div>
          </div>
          {/* Ligne summary avec icône */}
          <div className="flex flex-col">
            <div className="flex flex-row items-center gap-[6px]">
              <div className="w-[14px] h-[14px] bg-gray-200 rounded-full flex-shrink-0"></div>
              <div className="h-[14px] bg-gray-200 rounded w-3/4"></div>
            </div>
          </div>
          {/* Ligne date + status */}
          <div className="flex items-center justify-between mt-2">
            <div className="h-[12px] bg-gray-200 rounded w-28"></div>
            <div className="h-[20px] bg-gray-200 rounded w-16"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SkeletonList = ({ numberOfItems = 3 }) => {
  return (
    <div className="flex flex-col gap-2">
      {Array.from({ length: numberOfItems }).map((_, index) => (
        <SkeletonCard key={'skeleton-card-' + index} />
      ))}
    </div>
  );
};

const FormTypeSkeletonCard = () => {
  return (
    <div className="bg-white rounded-2xl border-2 border-gray-200 p-8 animate-pulse">
      <div className="flex flex-col items-center text-center">
        <div className="h-6 bg-gray-200 rounded w-2/3 mb-6"></div>
        <div className="mt-4 flex items-center gap-2">
          <div className="h-4 bg-gray-200 rounded w-20"></div>
          <div className="h-4 w-4 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  );
};

const FormTypeSkeleton = ({ numberOfCards = 2 }) => {
  return (
    <>
      {/* Header skeleton */}
      <div className="mb-8 animate-pulse">
        <div className="h-8 bg-gray-200 rounded w-48 mb-2"></div>
        <div className="h-5 bg-gray-200 rounded w-80"></div>
      </div>
      {/* Cards skeleton */}
      <div className="grid grid-cols-1 w-full md:grid-cols-2 gap-6">
        {Array.from({ length: numberOfCards }).map((_, index) => (
          <FormTypeSkeletonCard key={`form-type-skeleton-${index}`} />
        ))}
      </div>
    </>
  );
};

export { SkeletonList, SkeletonCard, FormTypeSkeleton, FormTypeSkeletonCard };

